import { render, staticRenderFns } from "./StickersPrint.vue?vue&type=template&id=6042b761&scoped=true"
import script from "./StickersPrint.vue?vue&type=script&lang=js"
export * from "./StickersPrint.vue?vue&type=script&lang=js"
import style0 from "./StickersPrint.vue?vue&type=style&index=0&id=6042b761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042b761",
  null
  
)

export default component.exports